<template>
  <div class="encrypt_wrap center">{{encryptedString}}</div>
</template>

<script>
export default {
    data() {
        return {
            encryptedString: ""
        };
    },
    components: {

    },
    created() {
        console.log(this.$encrypt.deviceEncrypt('6B694D84-67DE-4346-B3C8-340CDF06DE41'))
        let s = this.$route.query.s ? this.$route.query.s : ""
        this.encryptedString = this.$encrypt.deviceEncrypt(s)
    },
    methods: {

    }

}

</script>
<style scoped lang="scss">
.encrypt_wrap {
    width: 100%;
    padding: 30px 20px;
    box-sizing: border-box;
    word-break: break-all;
    font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/pages/encrypt/encrypt.vue